module.exports = __webpack_public_path__ + "img/VIRTUAL_ACCOUNT_BANK_Mandiri.06825455.svg";